<template>
    <div class="mt-4">
        <b-row>
            <b-col col lg="12" md="12" sm="12">
                <b-tabs>
                    <b-tab active>
                        <template slot="title">
                            <span class=""> User Information</span>
                        </template>
                        <table class="table table-striped detail-table mt-4">
                            <tbody>
                            <tr>
                                <td class="detail-table-label">Name</td>
                                <td>{{user.name}}</td>
                            </tr>
                            <tr>
                                <td class="detail-table-label">Email</td>
                                <td>{{user.email}}</td>
                            </tr>
                            <tr>
                                <td class="detail-table-label">Created</td>
                                <td>{{user.created_at}}</td>
                            </tr>
                            <tr>
                                <td class="detail-table-label">Updated</td>
                                <td>{{user.updated_at}}</td>
                            </tr>
                            <tr>
                                <td class="detail-table-label">Role</td>
                                <td>{{role}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-tab>

                    <b-tab v-if="user.doctor">
                        <template slot="title">
                            <span class=""> Doctor Information</span>
                        </template>
                        <div class="mt-4">
                            <doctor-detail-table :doctor="user.doctor"></doctor-detail-table>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import DoctorDetailTable from '@/views/Doctor/DetailTable';

  export default {
    props: {
      user: {
        type: Object,
        default: {}
      }
    },

    computed: {
      role() {
        return (this.user.role) ? this.user.role.name : null;
      }
    },

    components: {
      DoctorDetailTable
    },

    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/User/Detail/DetailBody.vue